<template>
    <LMarker :lat-lng="latLong">
        <LIcon 
            :icon-url="iconeMarcador" 
            :icon-size="[32, 38]" 
            :icon-anchor="[16, 38]"
            :popup-anchor="[0, -37]" 
        />
        <LPopup v-if="!isEmpty(texto)">{{ texto }}</LPopup>
    </LMarker>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { LMarker, LIcon, LPopup } from '@vue-leaflet/vue-leaflet';
import 'leaflet/dist/leaflet.css';
import { isEmpty } from '@/helper/funcoes';

const props = defineProps({
    lat: {
        type: Number,
        required: true,
        default: 0,
    },
    long: {
        type: Number,
        required: true,
        default: 0,
    },
    icone: {
        type: String,
        default: "",
    },
    texto: {
        type: String,
        default: "",
    },
});

const latLong = computed(() => [props.lat, props.long]);
const iconeMarcador = computed(() => props.icone || '/img/marcador-posicao.png');

</script>
